import * as React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import AuthService from '../services/auth.js';
import "../Amenities.css"

import EditIcon from '@mui/icons-material/Edit';


import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import SendIcon from '@mui/icons-material/Send';
import Divider from '@mui/material/Divider';
import Checkbox from '@mui/material/Checkbox';


import IconButton from '@mui/material/IconButton';
import Paper from '@mui/material/Paper';

import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import Chip from '@mui/material/Chip';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import LabelImportantIcon from '@mui/icons-material/LabelImportant';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';

import PersonIcon from '@mui/icons-material/Person';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import TextField from '@mui/material/TextField';

// import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import dayjs from 'dayjs';
import Drawer from '@mui/material/Drawer';

import apiClient, { shouldRedirectToLogin, getErrorMessage } from '../services/api-client';
import AppConfig from '../services/app-config';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';

import LiveThread from '../components/LiveThread';

// Resolve the org-level issues file config from AppConfig (with sensible defaults).
function issueAllowedTypes() {
  const raw = AppConfig.get('issues_allowed_file_types');
  if (typeof raw === 'string' && raw.trim() !== '') {
    return raw.split(',').map((s) => s.trim()).filter(Boolean);
  }
  return ['image/jpeg', 'image/png', 'image/webp'];
}

function issueMaxMb() {
  const raw = AppConfig.get('issues_max_file_mb');
  const n = Number(raw);
  return Number.isFinite(n) && n > 0 ? n : 5;
}

import Resizer from 'react-image-file-resizer';
import Avatar from '@mui/material/Avatar';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';
import ClearIcon from '@mui/icons-material/Clear';
import WarningIcon from '@mui/icons-material/Warning';
import DeleteIcon from '@mui/icons-material/Delete';
import ShareIcon from '@mui/icons-material/Share';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import InfoIcon from '@mui/icons-material/Info';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';

import PageHeader from '../components/PageHeader';

const statusChipColors = {
  'reportado': { bg: '#fff3e0', color: '#e65100' },
  'en_progreso': { bg: '#e3f2fd', color: '#1565c0' },
  'asignado': { bg: '#e8f5e9', color: '#2e7d32' },
  'programado': { bg: '#ede7f6', color: '#4527a0' },
  'en_espera': { bg: '#f3e5f5', color: '#7b1fa2' },
  'resuelto': { bg: '#e8f5e9', color: '#2e7d32' },
  'cancelado': { bg: '#fbe9e7', color: '#bf360c' },
};

const timelineDotColors = {
  'reportado': 'grey',
  'en_progreso': 'primary',
  'asignado': 'success',
  'programado': 'info',
  'en_espera': 'warning',
  'resuelto': 'success',
  'cancelado': 'error',
};

export default function Issue({setNavbarState, navbarState}) {
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' });
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(true);
  const [drawerShow, setDrawerShow] = React.useState(false);
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [refresh,setRefresh] = React.useState(false);
  const [issue,setIssue] = React.useState({});
  const [fullImageDialog, setFullImageDialog] = React.useState({ open: false, src: '' });
  const [confirmDialog, setConfirmDialog] = React.useState({ open: false, action: null });
  const [deleteCommentDialog, setDeleteCommentDialog] = React.useState({ open: false, commentDate: null });
  const [shareDialogOpen, setShareDialogOpen] = React.useState(false);
  const [categoryDialogOpen, setCategoryDialogOpen] = React.useState(false);
  const [categories,setCategories] = React.useState([]);
  const [copySuccess, setCopySuccess] = React.useState(false);
  const [currentUrl, setCurrentUrl] = React.useState('');
  const [aiDisclaimerOpen, setAiDisclaimerOpen] = React.useState(false);

  const issueId = new URLSearchParams(location.search).get('id');
  const apiUrl = process.env.REACT_APP_MGO_API_URL;

  const stateFriendlyNames = AppConfig.getLocal("issues")

  
  const triggerRefresh = () => {
    setRefresh(!refresh);
  }

  const updateIssue = (estado) => {
    if (estado === 'cancelado') {
      setConfirmDialog({ open: true, action: () => performUpdateIssue(estado) });
    } else {
      performUpdateIssue(estado);
    }
  }

  const performUpdateIssue = (estado) => {
    setLoading(true);
    setShowBackdrop(true);
    apiClient.post(`issue/update/${issueId}`, {estado: estado}, {}, { action: 'update_issue' })
      .then(response => {
        if (response.status === 200) {
          setSnackbar({ open: true, message: "Estado actualizado correctamente", severity: 'success' });
          fetchInfo(issueId);
        } else if (response.status === 422) {
          setSnackbar({ open: true, message: response.data.data.mensaje, severity: 'error' });
        }
        setLoading(false);
        setShowBackdrop(false);
      })
      .catch(error => {
        if(error.response && error.response.data && error.response.data.code === 422) {
          setSnackbar({ open: true, message: error.response.data.data.mensaje, severity: 'error' });
        }
        else  {
        console.error('Error fetching issues:', error);
        setSnackbar({ open: true, message: "Hubo un error al intentar actualizar el estado del ticket, porfavor intente mas tarde.", severity: 'error' })};
        setLoading(false);
        setShowBackdrop(false);
      });
  }

  const toggleSubscription = (e) => {
    setShowBackdrop(true);
    let subscribed_text = e.target.checked ? "true" : "false";
    apiClient.post(`issues/subscribe/${issueId}/${subscribed_text}`, {}, {}, { action: 'toggle_issue_subscription' })
    .then(response => {
      if (response.status === 200) {
        setIssue({...issue, subscribed: response.data.data.enabled});
        setSnackbar({ open: true, message: "Notificaciones actualizadas correctamente", severity: 'success' });
      }
      setShowBackdrop(false);
    })
    .catch(error => {
      console.error('Error toggling subscription:', error);
      setSnackbar({ open: true, message: "Hubo un error al intentar actualizar las notificaciones, porfavor intente mas tarde.", severity: 'error' });
      setShowBackdrop(false);
    });
  }

  const handleLiveSubmitComment = ({ text: commentText, image: img }) => {
    setShowBackdrop(true);
    if (commentText === "") {
      setSnackbar({ open: true, message: "No puedes enviar un comentario vacío, si estas agregando una imagen, porfavor agrega una descripcion.", severity: 'error' });
      setShowBackdrop(false);
      return;
    }
    let data = {
      comentario: commentText
    }
    if (img) {
      data.imagen = img;
    }
    apiClient.post(`issue/comment/${issueId}`, data, {}, { action: 'add_issue_comment' })
    .then(response => {
      AppConfig.parseResponse(response);
      if (response.status === 200) {
        setSnackbar({ open: true, message: "Comentario agregado", severity: 'success' });
        fetchInfo(issueId);
      } else if (response.status === 422) {
        setSnackbar({ open: true, message: response.data.data.mensaje, severity: 'error' });
      }
      setShowBackdrop(false);
    })
    .catch(error => {
      if(error.response && error.response.data && error.response.data.code === 422) {
        setSnackbar({ open: true, message: error.response.data.data.mensaje, severity: 'error' });
      }
      else  {
      console.error('Error commenting:', error);
      setSnackbar({ open: true, message: "Hubo un error al intentar agregar tu comentario, porfavor intente mas tarde.", severity: 'error' })};
      setShowBackdrop(false);
    });
  }

  // LiveThread callbacks
  const handleLiveCommentsChange = (updater) => {
    setIssue(prev => {
      const prevList = (prev && prev.comentarios) ? prev.comentarios : [];
      const next = typeof updater === 'function' ? updater(prevList) : updater;
      return { ...prev, comentarios: next };
    });
  };

  const handleLiveEntityUpdate = () => {
    // Refresh the issue from the server to pick up state / field changes.
    fetchInfo(issueId);
  };

  const handleLiveDeleteComment = (comentario) => {
    setDeleteCommentDialog({ open: true, commentDate: comentario.fecha });
  };

  const handleDrawerToggle = () => {
    setDrawerShow(!drawerShow);
  }

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const ceil = (option, dayjsClass) => {
    dayjsClass.prototype.ceil = function (unit, amount) {
        return this.add(amount - (this.get(unit) % amount), unit).startOf(unit);
    };
  };
  dayjs.extend(ceil);


  const fetchInfo = (id) => {

    apiClient.get(`issue/get/${id}`, {}, { action: 'fetch_issue' })
      .then(response => {
        if (response.status === 200) {
          const issueData = response.data.data;
          const lastEstado = issueData.estados[issueData.estados.length - 1];
          issueData.estado = lastEstado;
          setIssue(issueData);
          setLoading(false);
          setShowBackdrop(false);
        }
      })
      .catch(error => {
        setRedirect({ trigger: true, route: '/reportes' });
        console.error('Error fetching issues:', error);
        setSnackbar({ open: true, message: 'Hubo un error obteniendo los detalles del reporte', severity: 'error' });
        setShowBackdrop(false);
      });
  }

  const fabStyle = {
    position: 'fixed',
    bottom: 32,
    right: 32
  };

  const reservationDrawer = (
    <Card
    sx={{ py: 3, px: 2, display: 'block', marginLeft: 'auto', marginRight: 'auto', borderTopLeftRadius: "20px", borderTopRightRadius: "20px", borderBottomRightRadius: "0px", borderBottomLeftRadius: "0px", maxWidth: "550px", width: "100%" }}>
        
      <CardContent>
      </CardContent>
      <CardActions>
        <Button size="medium" color="inherit" variant="outlined" onClick={handleDrawerToggle}>Cancelar</Button>
        <Button size="medium" color="secondary" variant="contained" >Reservar</Button>
      </CardActions>
    </Card>
  );

  const handleRemoveImage = () => {
    // Retained for backwards-compat; LiveThread now owns image state.
  };

  const handleOpenFullImage = (src) => {
    setFullImageDialog({ open: true, src });
  };

  const handleCloseFullImage = () => {
    setFullImageDialog({ open: false, src: '' });
  };

  const handleCloseConfirmDialog = () => {
    setConfirmDialog({ open: false, action: null });
  };

  const handleOpenDeleteDialog = (commentDate) => {
    setDeleteCommentDialog({ open: true, commentDate });
  };

  const handleCloseDeleteDialog = () => {
    setDeleteCommentDialog({ open: false, commentDate: null });
  };

  const handleDeleteComment = () => {
    setShowBackdrop(true);
    apiClient.post(`issue/delete/comment/${issueId}`, { comment_id: deleteCommentDialog.commentDate }, {}, { action: 'delete_issue_comment' })
      .then(response => {
        if (response.status === 200) {
          setSnackbar({ open: true, message: "Comentario eliminado correctamente", severity: 'success' });
          fetchInfo(issueId);
        } else {
          setSnackbar({ open: true, message: "Error al eliminar el comentario", severity: 'error' });
        }
        setShowBackdrop(false);
        handleCloseDeleteDialog();
      })
      .catch(error => {
        console.error('Error deleting comment:', error);
        setSnackbar({ open: true, message: "Hubo un error al intentar eliminar el comentario", severity: 'error' });
        setShowBackdrop(false);
        handleCloseDeleteDialog();
      });
  };

  const handleShareClick = () => {
    setShareDialogOpen(true);
    setCurrentUrl(window.location.href);
  };

  const handleEditCategory = () => {
    setCategoryDialogOpen(true);
  };

  const handleCloseEditCategory = () => {
    setCategoryDialogOpen(false);
  };

  const handleCloseShareDialog = () => {
    setShareDialogOpen(false);
    setCopySuccess(false);
  };

  const handleCopyLink = () => {
    navigator.clipboard.writeText(currentUrl).then(() => {
      setCopySuccess(true);
      setTimeout(() => setCopySuccess(false), 2000);
    });
  };

  const handleOpenAiDisclaimer = () => {
    setAiDisclaimerOpen(true);
  };

  const handleCloseAiDisclaimer = () => {
    setAiDisclaimerOpen(false);
  };

  const setCategory = (category) => {
    let data_payload = {
      ticket: issueId,
      categoria: category
    }
    apiClient.post('issue/categorize', data_payload, {}, { action: 'categorize_issue' })
    .then(response => {
      if (response.status === 200) {
        setSnackbar({ open: true, message: "Categoria actualizada correctamente", severity: 'success'})
      }
    })
    .catch(error => {
      setSnackbar({ open: true, message: "Error al cambiar la categoria de este reporte.", severity: 'error' });
    })
    .finally(() => {
      handleCloseEditCategory();
    });
  }

  const fetchCategories = () => {
    apiClient.get('issue/categories', {}, { action: 'fetch_issue_categories' })
    .then(response => {
      if (response.status === 200) {
        setCategories(response.data.data)
      }
    })
    .catch(error => {
      console.error('Error fetching issues:', error);
    });

  }

  React.useEffect(() => {
    setNavbarState({...navbarState, showBack: false, showOptions: false, showSearch: false})
    if (issueId === null) {
      setRedirect({ trigger: true, route: '/reportes' });
    }
    if (AuthService.userRoleIncludes(['admin','receptor'])) {
      fetchCategories()
    }
    setShowBackdrop(true);
    setLoading(true);
    fetchInfo(issueId);
    
    // Set the current URL
    setCurrentUrl(window.location.href);
  }, [refresh]);

return (
    <>
    <Container maxWidth="sm" disableGutters>
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
    <Snackbar open={snackbar.open} autoHideDuration={3000} anchorOrigin={{ vertical: "top", horizontal: "center" }} sx={{mt: "3.2rem"}} onClose={handleSnackbarClose}>
      <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
        {snackbar.message}
      </Alert>
    </Snackbar>
    <Box sx={{ mt: 0 }}>
      <Backdrop open={showBackdrop} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
        {!loading && (
          <>
          {/* Hero image with overlay controls */}
          <Box
            sx={{
              position: 'relative',
              overflow: 'hidden',
              mb: -0.5,
              borderBottomLeftRadius: '24px',
              borderBottomRightRadius: '24px'
            }}
          >
            <img 
              src={`${apiUrl}/img/issue/${issueId}.jpg`} 
              alt="Issue Image" 
              style={{ width: '100%', display: 'block', maxHeight: '280px', objectFit: 'cover' }} 
            />
            <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0, px: 2, pt: { xs: 2, sm: 2.5 }, pb: 1.5 }}>
              <PageHeader title="Reporte" icon="shield-warning" onBack={() => navigate(-1)} variant="overlay" />
            </Box>
          </Box>

          {/* Content card */}
          <Card variant="outlined" sx={{ borderTopLeftRadius: 0, borderTopRightRadius: 0, borderRadius: '0 0 16px 16px', border: 'none', boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
            <CardContent sx={{ px: 2.5, pt: 2.5 }}>
              {/* Title + Status chip */}
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 1 }}>
                <Typography variant="h5" sx={{ fontWeight: 700, flex: 1, mr: 1 }}>
                  {issue.titulo}
                </Typography>
                {(() => {
                  const chipColor = statusChipColors[issue.estado.estado] || { bg: '#f5f5f5', color: '#616161' };
                  return (
                    <Chip
                      label={stateFriendlyNames[issue.estado.estado].nombre_corto}
                      size="small"
                      sx={{ fontWeight: 700, fontSize: '0.7rem', backgroundColor: chipColor.bg, color: chipColor.color, borderRadius: 1, flexShrink: 0 }}
                    />
                  );
                })()}
              </Box>

              {/* Description */}
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2, lineHeight: 1.6 }}>
                {issue.descripcion} 
              </Typography>
              
              {/* Meta info */}
              <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 1.5 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <AccessTimeIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
                  <Typography variant="caption" color="text.secondary">
                    {AppConfig.formatFriendlyDateWithYear(issue.estado.fecha)}
                  </Typography>
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                  <LocationOnIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
                  <Typography variant="caption" color="text.secondary">
                    {AppConfig.titleCase(issue.area)}
                  </Typography>
                </Box>
              </Box>

              {/* Notification subscription */}
              {AppConfig.getLocal("notification_enable") && issue.estado.estado !== 'cancelado' && issue.estado.estado !== 'resuelto' && <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                <Checkbox
                  checked={issue.subscribed}
                  onChange={toggleSubscription}
                  size="small"
                />
                <Typography variant="caption" color="text.secondary">
                  Recibir notificaciones sobre este reporte
                </Typography>
              </Box>}

              {/* Category chips */}
              {issue.categoria && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1.5 }}>          
                  <Chip 
                    key={issue.categoria} 
                    label={AppConfig.titleCase(issue.categoria)}
                    icon={<AutoAwesomeIcon sx={{fontSize: '1rem'}}/>}
                    onClick={handleOpenAiDisclaimer}
                    size="small"
                    sx={{ cursor: 'pointer' }}
                  />
                  {AuthService.userRoleIncludes(["admin","receptor"]) && (
                    <Chip 
                    edge="end" 
                    aria-label="edit" 
                    icon={<EditIcon sx={{ fontSize: '1rem' }} />} 
                    size="small"
                    onClick={handleEditCategory}
                    />)}
                </Box>
              )}
              {!issue.categoria && AuthService.userRoleIncludes(["admin","receptor"]) && (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, mb: 1.5 }}>   
                  <Chip 
                    edge="end" 
                    aria-label="edit"
                    icon={<LabelImportantIcon sx={{ fontSize: '1rem' }} />}
                    label="Agregar Categoria"
                    size="small"
                    onClick={handleEditCategory}
                  />
                </Box>
              )}

              {/* Timeline / Seguimiento */}
              <Divider sx={{ mb: 1.5 }} />
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                Seguimiento
              </Typography>
              <Timeline position="right" sx={{ p: 0, m: 0 }}>
                {issue.estados.slice().reverse().map((estado, index) => (
                  <TimelineItem key={`estado-${index}`} sx={{ minHeight: 50 }}>
                    <TimelineOppositeContent sx={{ flex: 0.3, py: 0.5, px: 0.5 }}>
                      <Typography variant="caption" color="text.secondary" sx={{ fontSize: '0.65rem' }}>
                        {AppConfig.formatFriendlyDateWithYear(estado.fecha)}
                      </Typography>
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot color={timelineDotColors[estado.estado] || 'grey'} sx={{ my: 0.5, width: 10, height: 10, p: 0 }} />
                      {index !== issue.estados.length - 1 && <TimelineConnector sx={{ minHeight: 20 }} />}
                    </TimelineSeparator>
                    <TimelineContent sx={{ py: 0.5, px: 1 }}>
                      <Typography variant="body2" sx={{ fontWeight: 600, fontSize: '0.8rem' }}>
                        {stateFriendlyNames[estado.estado].nombre_corto}
                      </Typography>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'flex', alignItems: 'center', gap: 0.3 }}>
                        <PersonIcon sx={{ fontSize: 12 }} /> {estado.usuario_nombre}
                      </Typography>
                    </TimelineContent>
                  </TimelineItem>
                ))}
              </Timeline>

              {/* Comments section (live) */}
              <LiveThread
                issueId={issueId}
                type="issue"
                comments={issue.comentarios || []}
                onCommentsChange={handleLiveCommentsChange}
                onEntityUpdate={handleLiveEntityUpdate}
                estados={stateFriendlyNames}
                canComment={AuthService.userRoleIncludes(["admin"]) || (issue.estado.estado !== 'cancelado' && issue.estado.estado !== 'resuelto')}
                onSubmitComment={handleLiveSubmitComment}
                onDeleteComment={handleLiveDeleteComment}
                currentUser={AuthService.getCurrentUserEmail()}
                imageMode={true}
                imageBaseUrl={`${apiUrl}/img/issue/${issueId}`}
                onOpenImage={handleOpenFullImage}
                allowedFileTypes={issueAllowedTypes()}
                maxFileMb={issueMaxMb()}
              />

            </CardContent>

            {/* Action buttons */}
            {AuthService.userRoleIncludes(["admin"]) && (
              <CardActions sx={{ px: 2.5, pb: 2.5, pt: 1, gap: 1 }}>
                {stateFriendlyNames[issue.estado.estado].siguiente_estado.map((estado, index) => (
                  estado === 'cancelado' ? (
                    <Button
                      key={`estado-${index}`}
                      variant="outlined"
                      fullWidth
                      startIcon={<CancelOutlinedIcon />}
                      onClick={() => updateIssue(estado)}
                      sx={{
                        borderColor: '#d32f2f', color: '#d32f2f', borderRadius: 2,
                        textTransform: 'none', fontWeight: 600,
                        '&:hover': { borderColor: '#b71c1c', backgroundColor: '#fbe9e7' }
                      }}
                    >
                      Cancelar
                    </Button>
                  ) : (
                    <Button
                      key={`estado-${index}`}
                      variant="contained"
                      fullWidth
                      startIcon={<CheckCircleOutlinedIcon />}
                      onClick={() => updateIssue(estado)}
                      sx={{
                        backgroundColor: '#2e7d32', borderRadius: 2,
                        textTransform: 'none', fontWeight: 600,
                        '&:hover': { backgroundColor: '#1b5e20' }
                      }}
                    >
                      {stateFriendlyNames[estado].nombre_corto}
                    </Button>
                  )
                ))}
                {(issue.estado.estado === 'cancelado' || issue.estado.estado === 'resuelto') && (
                  <Button
                    key="reabrir"
                    variant="outlined"
                    color="secondary"
                    fullWidth
                    onClick={() => updateIssue('en_progreso')}
                    sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}
                  >
                    Reabrir Ticket
                  </Button>
                )}
              </CardActions>
            )}
          </Card>
          </>)}
    </Box>

    {!loading && (
    <>
    <Drawer
          // container={container}
          anchor="bottom"
          variant="temporary"
          open={drawerShow}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          PaperProps={{ elevation: 0, style: { backgroundColor: "transparent" } }}
          sx={{
            display: { xs: 'block' },
            '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '440' },
          }}
        >
          {reservationDrawer}
    </Drawer>
    </>
    )}
    </Container>
    <Dialog
      open={fullImageDialog.open}
      onClose={handleCloseFullImage}
      maxWidth="xl"
      fullWidth
    >
      <DialogContent>
        <IconButton
          aria-label="close"
          onClick={handleCloseFullImage}
          sx={{
            position: 'absolute',
            right: 2,
            top: 2
          }}
        >
          <ClearIcon />
        </IconButton>
        <img 
          src={fullImageDialog.src} 
          alt="Full size comment image" 
          style={{ width: '100%', height: 'auto' }}
        />
      </DialogContent>
    </Dialog>
    <Dialog
      open={confirmDialog.open}
      onClose={handleCloseConfirmDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"¿Estás seguro de que quieres cancelar este ticket?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <Box display="flex" alignItems="center">
            <WarningIcon color="warning" sx={{ mr: 1 }} />
            El ticket se podra reabrir pero quedara el estado en el historial.
          </Box>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseConfirmDialog} color="primary">
          No, mantener abierto
        </Button>
        <Button 
          onClick={() => {
            confirmDialog.action();
            handleCloseConfirmDialog();
          }} 
          color="secondary" 
          variant="contained"
          autoFocus
        >
          Sí, cancelar ticket
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog
      open={deleteCommentDialog.open}
      onClose={handleCloseDeleteDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"¿Estás seguro de que quieres eliminar este comentario?"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Esta acción no se puede deshacer. El comentario será eliminado permanentemente.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDeleteDialog} color="primary">
          Cancelar
        </Button>
        <Button 
          onClick={handleDeleteComment}
          color="secondary" 
          variant="contained"
          autoFocus
        >
          Eliminar
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog open={shareDialogOpen} onClose={handleCloseShareDialog}>
      <DialogTitle>Compartir Reporte</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Comparte este enlace para que otros puedan ver el reporte:
        </DialogContentText>
        <TextField
          fullWidth
          value={currentUrl}
          margin="dense"
          InputProps={{
            readOnly: true,
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseShareDialog}>Cerrar</Button>
        <Button 
          onClick={handleCopyLink} 
          color="secondary" 
          variant="text" 
          startIcon={<ContentCopyIcon />}
          sx={{pl: 2}}
        >
          {copySuccess ? 'Copiado!' : 'Copiar enlace'}
        </Button>
      </DialogActions>
    </Dialog>
    <Dialog open={categoryDialogOpen} onClose={handleCloseEditCategory} sx={{minWidth: 400}}>
      <DialogTitle>Edita la Categoria del Reporte</DialogTitle>
      <DialogContent>
        <FormControl fullWidth variant="outlined" sx={{mt: 1}}>
        <InputLabel id="category-select-label">Categoria</InputLabel>
          <Select
            labelId="category-select-label"
            id="category-select"
            label="Categoria"
            value={issue.categoria}
            onChange={
              (event) => {
                setIssue({...issue, categoria: event.target.value})
                setCategory(event.target.value)
              }
            }
          >
            {categories.map((categoria, index) => (
              <MenuItem key={index} value={categoria}>
                {AppConfig.titleCase(categoria)}
              </MenuItem>
            ))}
            
          </Select>
        </FormControl>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseEditCategory}>Cerrar</Button>
      </DialogActions>
    </Dialog>
    <Dialog
      open={aiDisclaimerOpen}
      onClose={handleCloseAiDisclaimer}
      aria-labelledby="ai-disclaimer-dialog-title"
      aria-describedby="ai-disclaimer-dialog-description"
    >
      <DialogTitle id="ai-disclaimer-dialog-title">
        <Box display="flex" alignItems="center">
          <AutoAwesomeIcon sx={{ mr: 1}} />
          Uso de Inteligencia Artificial
        </Box>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="ai-disclaimer-dialog-description">
          La categoría de este reporte ha sido sugerida por un sistema de Inteligencia Artificial. 
          Esta sugerencia es una ayuda para la clasificación, pero puede no ser 100% precisa. 
          <br/>
          Estas categorías servirán para que la administración tenga mejores reportes acerca de los tipos de problemas que se presentan.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseAiDisclaimer} color="primary">
          Entendido
        </Button>
      </DialogActions>
    </Dialog>
  </>);
}
